import { FieldOkSearchConfig } from '@softapps/core/pages';
import { LagersymFieldOkSearchResultViewComponent } from './search-result-view/search-result-view.component';

export const lagersymSearchPageConfig: FieldOkSearchConfig<any> = {
  name: 'lagersym',
  view: LagersymFieldOkSearchResultViewComponent,
  options: {
    autoLoad: true
  }
};
